import { useState } from 'react'
import useEventCallback from '../../utils/useEventCallback'
import { isGE } from '../../Device'

const useTooltip = () => {
  const [tooltip, setTooltip] = useState(false)

  const showTooltip = useEventCallback(() => setTooltip(true), [setTooltip])
  const hideTooltip = useEventCallback(() => setTooltip(false), [setTooltip])

  const mouseListeners = isGE()
    ? {
        onMouseOver: showTooltip,
        onMouseOut: hideTooltip
      }
    : {}

  return { tooltip, setTooltip, mouseListeners }
}

export default useTooltip
